<template>
	<Row class="flex-align-center">
		<Row v-if="hasAccessToAllSpaces" class="flex-align-center">
			<h3 class="reg">Include data from spaces you are not a collaborator in</h3>
			<IncludeDataForAdminExplanation class="mx-1 mt-1" />
			<v-switch class="dark small" v-model="includeSpacesForAdmin" inset dense color="white" />
		</Row>
		<template v-else>
			<template v-if="projectName">
				<h3 class="reg">in "{{ projectName }}."&nbsp;</h3>
				<h3 @click="showEverything" class="reg link mx-2">Show everything</h3>
			</template>
			<template v-else>
				<h3 class="reg">for features you have collaborator access to.</h3>
			</template>
		</template>
		<TaskLogListFilterDatePicker
			v-if="dateRangeFilter"
			class="ml-2"
			:dateRange.sync="dateRangeFilterLocal"
			:maxDaysFromToday="MAX_DAYS_FROM_TODAY_TO_VIEW_STATS"
		/>
	</Row>
</template>
<script>
import IncludeDataForAdminExplanation from '@/components/Analytics/IncludeDataForAdminExplanation.vue';
import { MAX_DAYS_FROM_TODAY_TO_VIEW_STATS } from '@/components/Analytics/analytics.const.js';
import TaskLogListFilterDatePicker from '@/components/TaskLog/TaskLogListFilterDatePicker.vue';
import { selectedProject } from '@/store/modules/selectedProject/getters.js';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { ALL_PROJECTS_VIRTUAL_ID } from '@/utils/projects.const';
export default {
	name: 'AnalyticsDataFilter',
	components: {
		TaskLogListFilterDatePicker,
		IncludeDataForAdminExplanation,
	},
	props: {
		dateRangeFilter: { type: Array },
		includeAllSpacesForAdmin: { type: Boolean },
		hasAccessToAllSpaces: { type: Boolean, default: false },
	},
	computed: {
		...mapGettersShorthand({ selectedProject }),
		projectName() {
			return this.selectedProject?.title;
		},
		includeSpacesForAdmin: {
			get() {
				return this.includeAllSpacesForAdmin;
			},
			set(value) {
				this.$emit('include-all-spaces-for-admin-changed', value);
			},
		},
		dateRangeFilterLocal: {
			get() {
				return this.dateRangeFilter;
			},
			set(value) {
				this.$emit('update:dateRangeFilter', value);
			},
		},
	},
	methods: {
		showEverything() {
			this.$router.push({ params: { spaceId: ALL_PROJECTS_VIRTUAL_ID } });
		},
	},
	data() {
		return {
			MAX_DAYS_FROM_TODAY_TO_VIEW_STATS,
		};
	},
};
</script>
<style scoped lang="scss">
::v-deep {
	.dark .v-input--switch__track {
		background: #707070 !important;
	}
	.dark.v-input--is-label-active .v-input--switch__track {
		background: var(--bold-border-color) !important;
	}
	.small {
		transform: scale(0.75);
	}
	.v-input--selection-controls {
		padding-top: 0px;
	}
	.v-input--switch__track {
		background: #ced0da !important;
		opacity: 1 !important;
		transition: all 0.15s;
	}
	.v-input--is-label-active .v-input--switch__track {
		opacity: 1 !important;
		background: var(--bold-border-color) !important;
	}
}
</style>
